// extracted by mini-css-extract-plugin
export default {"textureBackground":"fboKPDLV_q2C5mtMTbhl","dark":"i1YPAofgyu5Jg6MVaoFb","custom":"_8NaK6UIATlzYnZ9QZxQ","absolute":"yixAXbhtSzLoXmVEMVTP"};